import React from 'react';
import { useSelector } from 'react-redux';
import { IconTunnelProxiesOutline } from '@saucelabs/ds-icons';
import { Tooltip } from '@saucelabs/ds-tooltip';
import classnames from 'classnames';
import { selectors as tunnelSelectors } from '@saucelabs/sl-module-tunnels';

import { isTunnelStillRunning } from '../../../utils';
import { utils as testConfigurationUtils } from '../../../ducks/testConfiguration';
import constants from '../constants';

const {
  DEFAULT_TUNNEL_NAME,
} = constants;

interface TunnelIndicatorProps {
  presetId: string,
  tunnel: string | null,
}

type ParsedTunnel = {
  tunnelName: string
  tunnelOwner: string
}

const TunnelIndicator: React.FC<TunnelIndicatorProps> = ({ presetId, tunnel }) => {
  const runningTunnels = useSelector(tunnelSelectors.filteredUserTunnelsSelector);
  const isTunnelRunning = tunnel && isTunnelStillRunning(tunnel, runningTunnels);
  const {
    tunnelName,
    tunnelOwner,
  }: ParsedTunnel = testConfigurationUtils.parseTunnelNameString(tunnel as string);
  const tunnelDisplay = tunnelOwner ? `${tunnelOwner}/${tunnelName || DEFAULT_TUNNEL_NAME}` : '';
  const tooltipContent = (
    <div>
      { !tunnel && <span>Tunnel inactive</span>}
      { tunnel && isTunnelRunning && <span>{tunnelDisplay}</span> }
      { tunnel && !isTunnelRunning && <span>{`${tunnelDisplay} (Inactive)`}</span> }
    </div>
  );

  return (
    <Tooltip
      delay={300}
      placement="top"
      title={tooltipContent}
    >
      <span id={`preset-tunnel-indicator-${presetId}-tooltip`}>
        <IconTunnelProxiesOutline
          className={classnames('w-2 h-2 ml-1 align-middle fill-current', {
            'text-gray-500': !tunnel,
            'text-blue-700': tunnel && isTunnelRunning,
            'text-orange-600': tunnel && !isTunnelRunning,
          })}
        />
      </span>
    </Tooltip>
  );
};

export default TunnelIndicator;
